import styled from "styled-components";

export const StyledTableCell = styled.div<{
  isToday: boolean;
  areThereEvents: boolean;
  color: string;
  backgroundColor: string;
}>`
  width: 11rem;
  height: 5.2rem;
  box-shadow: 0.3125rem 0.3125rem 0.3125rem 0px rgba(0, 0, 0, 0.3);
  filter: drop-shadow(0.3125rem 0.3125rem 0.3125rem rgba(0, 0, 0, 0.3));
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  color: ${(props) => props.color};
  background-color: ${(props) => props.backgroundColor};
  ${(props) => (props.isToday ? "border: 0.1875rem solid red" : "")};
  cursor: ${(props) => (props.areThereEvents ? "pointer" : "default")};
`;

export const StyledRightContainer = styled.div`
  flex-grow: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 0.3125rem 0.3125rem 0.3125rem;
  box-sizing: border-box;

  #number {
    display: inline-block;
    width: 100%;
    text-align: right !important;
    line-height: 1.75rem;
    box-sizing: border-box;
    font-size: 2rem;
    font-family: "Palatino Linotype", serif;
  }

  #info {
    width: 100%;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    align-items: flex-start;
    justify-content: end;

    font-weight: 300;
    text-align: left;
    line-height: 1;

    p {
      font-size: 0.9rem;
      margin: 0;
      -webkit-line-clamp: 3;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      overflow: hidden;
      font-family: "Open Sans", sans-serif;
    }
  }
`;

export const StyledLeftContainer = styled.div`
  position: relative;
  height: 100%;
  min-width: 40%;
  max-width: 40%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.2rem 0 0.2rem 0.2rem;
  box-sizing: border-box;
  overflow: hidden;
  box-sizing: border-box;
`;
